export enum PregnancyTypeEnum {
	SINGLE = 1,
	DOUBLE = 2,
	TRIPLEORMORE = 3,
	IGNORED = 4,
}
